import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { EditableFormContextCard } from "../context-cards";
import { SendSMSAction } from "./SendSMSAction";
import { SendChatAction } from "./SendChatAction";
import { SendEmailAction } from "./SendEmailAction";

export interface TicketActionProps {
  action: NonNullable<TellescopeModelFromName<"tickets">["actions"]>[number];
  onCompleteAction: () => void;
  enduserId?: string;
}

export const TicketAction = ({ action, onCompleteAction, enduserId }: TicketActionProps) => {
  switch (action.type) {
    case "Complete Form":
      return (
        <EditableFormContextCard
          formResponseId={action.info.formResponseId ?? ""}
          isEditing={!action.completedAt}
          onSubmit={onCompleteAction}
        />
      );
    case "Create Prescription":
      return null; // TODO: implement once we have prescription support
    case "Send SMS":
      return <SendSMSAction {...action} onSend={onCompleteAction} enduserId={enduserId} />;
    case "Send Email":
      return <SendEmailAction {...action} onSend={onCompleteAction} enduserId={enduserId} />;
    case "Send Chat":
      return <SendChatAction {...action} onSend={onCompleteAction} enduserId={enduserId} />;
  }
};
